import { difference, isBoolean } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { FeatureFlag } from '@swf/core/enums';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

let buffer: FeatureFlag[] = [];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let chain: Promise<any> = Promise.resolve();

export const flush = () => {
  const tmp = buffer;
  buffer = [];
  return tmp;
};

const useFeature = (flag: FeatureFlag): boolean => {
  const { feature } = useDispatch<Dispatch>();
  const selector = useCallback((state) => select.feature.check(state, flag), [flag]);
  const value = useSelector(selector);
  const hasClientSession = useSelector(select.session.hasClientSession);

  if (!buffer.includes(flag) && !isBoolean(value)) {
    buffer.push(flag);
  }

  useEffect(() => {
    if (!hasClientSession) return;

    chain = chain.then(async () => {
      const features = [...buffer];
      if (features.length) {
        await feature.check({ features });
        buffer = difference(buffer, features);
      }
    });
  }, [hasClientSession, feature, flag]);

  return value;
};

export default useFeature;
